import { apiClient } from './client';
import { CounselorTarget, TargetProgress } from '../types/target';

export interface ListTargetsParams {
  userId?: number;
  periodMonth?: number;
  periodYear?: number;
}

export const listTargets = async (params: ListTargetsParams = {}): Promise<CounselorTarget[]> => {
  const { data } = await apiClient.get('/targets', { params });
  return data.data;
};

export interface SetTargetPayload {
  userId: number;
  periodMonth: number;
  periodYear: number;
  leadTarget?: number;
  registrationTarget?: number;
  admissionTarget?: number;
  paymentTarget?: number;
  notes?: string;
}

export const setTarget = async (payload: SetTargetPayload): Promise<CounselorTarget> => {
  const { data } = await apiClient.post('/targets', payload);
  return data.data;
};

export const deleteTarget = async (id: number): Promise<void> => {
  await apiClient.delete(`/targets/${id}`);
};

export const getTargetProgress = async (id: number): Promise<TargetProgress> => {
  const { data } = await apiClient.get(`/targets/${id}/progress`);
  return data.data;
};
